import _styled from "styled-components";
const _excluded = ["style", "className", "children", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import { VIEWBOXES } from '../consts';
import useIconVariation from '../useIconVariation';
/**
 * A component for rendering single color icons as inline SVGs.
 */
const Icon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children,
      size = 24
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledSvg, _extends({
    ref: ref,
    height: size,
    width: size,
    viewBox: VIEWBOXES._24,
    fill: "currentColor",
    "aria-hidden": "true" // Icons are generally decorative and should not be read out to screen readers by default.
    ,

    className: className
  }, props, {
    $_css: [{
      flex: 'none'
    }, style].filter(Boolean)
  }), children);
});
Icon.displayName = 'Icon';
Icon.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Icon content, if rendering a custom SVG */
  children: PropTypes.any,
  /** Square size of icon (in pixels, defaults to 24) */
  size: PropTypes.number
};
export const generateRenderedIcon = (icons, name) => {
  const RenderedIcon = (props, ref) => {
    const variations = useIconVariation({
      size: props.size,
      icons: Array.isArray(icons) ? icons : [icons]
    });
    const viewBox = variations === null || variations === void 0 ? void 0 : variations[0].viewBox;
    return /*#__PURE__*/React.createElement(Icon, _extends({
      "data-testid": name,
      ref: ref,
      viewBox: viewBox,
      "aria-label": name // If this icon is used in an icon button, we override aria-hidden and this label gets used.
    }, props), variations.map((_ref2, index) => {
      let {
        d,
        fill
      } = _ref2;
      return /*#__PURE__*/React.createElement("path", {
        key: index,
        d: d,
        fill: fill
      });
    }));
  };
  return RenderedIcon;
};
export default Icon;
var _StyledSvg = _styled("svg").withConfig({
  displayName: "Icon___StyledSvg",
  componentId: "sc-1qxn6g3-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Icon.js.map